import { Base } from "./Base";
import { User } from "./User";
import { ICountry, IBase, IContact, ETeamType, EContactStatus } from "./shared/types";
import { L } from "@/common/filters";

export class ContactBase extends Base implements IContact {
  HalloId: string; //system generated surrogate key.
  Name: string;
  Catchword: string; //if Type==ContactType.Individual
  Avatar: string;
  CoverImage: string;
  Region: ICountry;
  Email: string;
  Mobile: string;
  QRCode: string;

  Prefix?: string;
  GivenName: string;
  Surname: string;
  Gender?: 'male' | 'female';
  Status: EContactStatus;

  protected _propertyNames = [
    'HalloId', 'Name', 'Catchword', 'Avatar', 'CoverImage', 'Region','Email','Mobile','QRCode',
    'Prefix', 'GivenName', 'Surname', 'Gender', 'Status'
  ];

  constructor(contact?:IBase) {
    super();
    if (contact) {
        this.Properties = contact;
    }
  }

  set Properties(contact:IBase) {
    for (let p in contact) {
      if (this._propertyNames.indexOf(p) != -1) {
        this[p] = contact[p];
      }
    }
  }

  set PropertiesFromStorage(data) {
    if (!data && data.id) {
      return;
    }
    let u:User = new User()
    u.PropertiesFromStorage = data;
    this.Properties = u.ContactProperties;
  }

  get NameCapitalLetter() : string {
    return this.Name.substr(0,1).toLocaleUpperCase();
  }

  protected _loadingAvatar: boolean = true;
  get LoadingAvatar() : boolean {
    return this._loadingAvatar;
  }

  onAvatarLoaded(args) {
    setTimeout(() => {
      this._loadingAvatar = false;
    },500);
  }
  
  get AvatarImage() : string {
    return this.Avatar || '~/images/hallo.user.png';
  }

  get DisplayName() :string {
    return this.Name;
  }
}

export class Contact extends ContactBase implements IContact {
  HalloId: string; //system generated surrogate key.
  Name: string;
  Catchword: string; //if Type==ContactType.Individual
  Avatar: string;
  CoverImage: string;
  Region: ICountry;
  Email: string;
  Mobile: string;
  QRCode: string;
  
  Owner: User;
  Members: Array<User>;
  Status: EContactStatus = null;
  Type: ETeamType = null;

  ListIndex?: number;

  protected _propertyNames = [
    'HalloId', 'Name', 'Catchword', 'Avatar', 'CoverImage', 'Region','Email','Mobile','QRCode',
    'Owner', 'Members', 'Status', 'Type'
  ];

  constructor(contact?:IContact) {
    super();
    if (contact) {
        this.Properties = contact;
    }
  }

  set Properties(contact:IContact) {
    for (let p in contact) {
      if (p=='Owner') {
        this[p] = new User(contact[p]);
      } else if (p=='Members') {
        this[p] = contact[p].map((member) => {
          return new User(member);
        }, this);
      } else if (this._propertyNames.indexOf(p) != -1) {
        this[p] = contact[p];
      }
    }
  }

  get Base() : ContactBase {
    return <ContactBase> this;
  }

  get AcceptStatus() : string {
    return (this.Status==EContactStatus.Invited) ? L('accept') : '';
  }

  get Added() : boolean {
    return this.Status==EContactStatus.Added;
  }

  get TypeText() : string {
    return L('contactType' + ETeamType[this.Type]);
  };

  get StatusTypeText() : string {
    let t:string;
    t = (this.Status==EContactStatus.Invited) ? 'Invited' :
        (this.Status==EContactStatus.Blocked) ? 'Blocked' : ETeamType[this.Type];
    return L('contactType' + t);
  };

  
  get AvatarImage() : string {
    return this.Avatar || ((this.Type==ETeamType.Group) ? '~/images/hallo.users.png' : '~/images/hallo.user.png');
  }

  get DisplayName() :string {
    let n:string = '';
    if (this.Type==ETeamType.Group) {
      n = ' (' + ((this.Members && this.Members.length>0) ? this.Members.length : 0) + ')';
    }
    return this.Name + n;
  }

  accept = () => {
    console.log('Accept this contact: ' + this.Name);
  }
}
